import type { SortMethodsMap } from './types'

export const sorter = <T,>(orderType: keyof SortMethodsMap<T>, sortKey: string) => {
  const x: SortMethodsMap<T> = {
    none: { method: () => () => 0 },
    asc: {
      method: (sortKey: string) => (a, b) => {
        if (a?.[sortKey] === undefined || b?.[sortKey] === undefined) {
          return 0
        }

        if (!isNaN(a?.[sortKey] - b?.[sortKey])) {
          return a?.[sortKey] - b?.[sortKey]
        }

        return String(a[sortKey]).toLowerCase().localeCompare(String(b[sortKey]).toLowerCase())
      }
    },
    desc: {
      method: (sortKey: string) => (a, b) => {
        if (!a?.[sortKey] || !b?.[sortKey]) {
          return 0
        }

        if (!isNaN(b?.[sortKey] - a?.[sortKey])) {
          return b?.[sortKey] - a?.[sortKey]
        }

        return String(b[sortKey]).toLowerCase().localeCompare(String(a[sortKey]).toLowerCase())
      }
    }
  }

  return x[orderType].method(sortKey)
}
